import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { TripsLayout } from '../Layout';

function TripTab(props) {
    var currentUser = props.oidc.user;
        const formRefs = useRef({});
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    
    const handleFormLoad = useCallback(() => {
     props.tripFormLoad(formRefs);
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='DD42EEAC-1CEB-4D2E-AA57-7D4A3766716D'
                layoutName='OMSalesOrderDataEntryTripForm'
                defaultFormSchema={TripsLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TripTab);
